(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anime-hub"] && !Shopify.designMode) return;
  try {
    

function initializeAnimeHub(root){
  if(root.dataset.initialized)return;
  root.dataset.initialized='true';
  const dialog=root.querySelector('.merry-dialog');
  const art=dialog.querySelector('.merry-dialog__ship');
  const label=dialog.querySelector('p');
  const preloaded=new Set();
  let timer;
  let destination;
  const clear=()=>{clearTimeout(timer);destination=null;if(dialog.open)dialog.close()};
  const finish=()=>{clearTimeout(timer);if(destination){const url=destination;destination=null;window.location.assign(url)}};
  root.querySelectorAll('[data-anime-transition]').forEach(link=>{
    const preload=()=>{if(preloaded.has(link.dataset.transitionArt))return;const image=new Image();image.src=link.dataset.transitionArt;preloaded.add(image.src)};
    link.addEventListener('pointerenter',preload,{once:true});
    link.addEventListener('focus',preload,{once:true});
    link.addEventListener('click',event=>{
      if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||window.matchMedia('(prefers-reduced-motion: reduce)').matches||!dialog.showModal)return;
      if(dialog.open)return;
      event.preventDefault();destination=link.href;
      art.src=link.dataset.transitionArt;
      dialog.dataset.effect=link.dataset.animeTransition;
      label.textContent=link.dataset.transitionLabel;
      dialog.showModal();timer=setTimeout(finish,link.dataset.animeTransition==='cyberpunk'?2300:1300);
    });
  });
  dialog.querySelector('button').addEventListener('click',finish);
  dialog.addEventListener('cancel',clear);
  window.addEventListener('pageshow',clear);
}
document.querySelectorAll('.anime-hub, .anime-spotlight').forEach(initializeAnimeHub);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.anime-hub, .anime-spotlight').forEach(initializeAnimeHub));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anime-spotlight"] && !Shopify.designMode) return;
  try {
    
function initializeAnimeSpotlight(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const slides=[...root.querySelectorAll('[data-slide]')];
  const dots=[...root.querySelectorAll('[data-go]')];
  const pause=root.querySelector('[data-pause]');
  const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  let current=0,paused=root.dataset.autoplay!=='true'||motion.matches,timer,hovered=false,focused=false,selected=false;
  function schedule(){clearTimeout(timer);if(!paused&&!hovered&&!focused&&!selected&&!document.hidden&&slides.length>1)timer=setTimeout(()=>show(current+1),Number(root.dataset.interval)||6000)}
  function show(index){current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>{const active=i===current;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active));slide.inert=!active});dots.forEach((dot,i)=>{dot.classList.toggle('is-active',i===current);dot.setAttribute('aria-pressed',String(i===current))});schedule()}
  function syncPause(){pause.setAttribute('aria-label',paused?pause.dataset.playLabel:pause.dataset.pauseLabel);pause.querySelector('span').textContent=paused?'▶':'Ⅱ'}
  root.querySelector('[data-prev]').addEventListener('click',()=>show(current-1));
  root.querySelector('[data-next]').addEventListener('click',()=>show(current+1));
  dots.forEach(dot=>dot.addEventListener('click',()=>show(Number(dot.dataset.go))));
  pause.addEventListener('click',()=>{paused=!paused;syncPause();schedule()});
  root.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){hovered=true;schedule()}});
  root.addEventListener('pointerleave',()=>{hovered=false;schedule()});
  root.addEventListener('focusin',()=>{focused=true;schedule()});
  root.addEventListener('focusout',event=>{if(!root.contains(event.relatedTarget)){focused=false;schedule()}});
  root.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();show(current+(event.key==='ArrowRight'?1:-1))}});
  const visibility=()=>schedule();document.addEventListener('visibilitychange',visibility);
  const changeMotion=()=>{if(motion.matches){paused=true;syncPause();schedule()}};motion.addEventListener('change',changeMotion);
  const select=event=>{const index=slides.findIndex(slide=>slide.dataset.block===event.detail.blockId);if(index>=0){selected=true;show(index)}};
  const deselect=()=>{selected=false;schedule()};root.addEventListener('shopify:block:select',select);root.addEventListener('shopify:block:deselect',deselect);
  const unload=event=>{if(event.target.contains(root)){clearTimeout(timer);document.removeEventListener('visibilitychange',visibility);motion.removeEventListener('change',changeMotion);document.removeEventListener('shopify:section:unload',unload)}};document.addEventListener('shopify:section:unload',unload);
  syncPause();schedule();
}
document.querySelectorAll('.anime-spotlight').forEach(initializeAnimeSpotlight);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.anime-spotlight').forEach(initializeAnimeSpotlight));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
